export const SET_USER_BRAND_SDK = "SET_USER_BRAND_SDK";

export function setUserBrandSDK(userBrandSDK) {
	return { type: SET_USER_BRAND_SDK, userBrandSDK };
}
